/* tslint:disable */
type RelationType =
  'All' |
  'Parent' |
  'Child' |
  'None';
module RelationType {
  export const ALL: RelationType = 'All';
  export const PARENT: RelationType = 'Parent';
  export const CHILD: RelationType = 'Child';
  export const NONE: RelationType = 'None';
  export function values(): RelationType[] {
    return [
      ALL,
      PARENT,
      CHILD,
      NONE
    ];
  }
}

export { RelationType }